require('../../modules/es.object.define-property');
var path = require('../../internals/path');

var Object = path.Object;

var defineProperty = module.exports = function defineProperty(it, key, desc) {
  return Object.defineProperty(it, key, desc);
};

if (Object.defineProperty.sham) defineProperty.sham = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/object/define-property.js
// module id = 442
// module chunks = 0